import { render, staticRenderFns } from "./GlobalTextEditorDisplay.vue?vue&type=template&id=c031e9be&scoped=true"
import script from "./GlobalTextEditorDisplay.vue?vue&type=script&lang=js"
export * from "./GlobalTextEditorDisplay.vue?vue&type=script&lang=js"
import style0 from "./GlobalTextEditorDisplay.vue?vue&type=style&index=0&id=c031e9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c031e9be",
  null
  
)

export default component.exports